export const hasQuestGoal = (user, goalKey) => {
  if (!user.currentQuest || user.currentQuest.completed) return false;

  const goal = user.currentQuest.progress[goalKey];
  if (!goal) return false;
  return goal.current < goal.target;
};
